document.addEventListener('alpine:init', () => {
    Alpine.data('bulkSelection', (config = {}) => ({
        selectedAll: false,
        pageItemIds: config.pageItemIds ?? {},
        selectedItemIds: config.selectedItemIds ?? [],
        excludedItemIds: config.excludedItemIds ?? [],
        allItemsSelected: config.allItemsSelected ?? false,
        totalItems: config.totalItems ?? 0,
        selectAllRef: config.selectAllRef ?? null,
        relatedItems: config.relatedItems ?? {},

        selectedIds: {},
        hasWatcher: false,

        toggleAll(state) {
            if (this.allItemsSelected && !state) {
                this.allItemsSelected = false;
                this.selectedItemIds = [];
                this.excludedItemIds = [];
            }

            Object.keys(this.selectedIds).forEach((key) => {
                const id = Number.parseInt(key, 10);
                this.selectedIds[key] = state;

                if (this.allItemsSelected && state) {
                    this.toggleExcluded(key, true);
                    return;
                }

                if (state) {
                    this.addSelectedItemId(id);
                    return;
                }

                this.removeSelectedItemId(id);
            });

            this.$nextTick(() => this.updateHeaderState());
        },

        init() {
            this.selectedAll = false;

            this.$nextTick(() => {
                this.syncSelection();

                if (!this.hasWatcher) {
                    this.$watch('pageItemIds', () => this.syncSelection());
                    this.hasWatcher = true;
                }
            });
        },

        syncSelection() {
            this.selectedIds = { ...this.pageItemIds };

            if (this.allItemsSelected) {
                Object.keys(this.selectedIds).forEach((key) => {
                    const id = Number.parseInt(key, 10);
                    this.selectedIds[key] = !this.excludedItemIds.includes(id);
                });
            } else {
                Object.keys(this.selectedIds).forEach((key) => {
                    const id = Number.parseInt(key, 10);
                    this.selectedIds[key] = this.selectedItemIds.includes(id);
                });
            }

            this.updateHeaderState();
        },

        toggle(state, key) {
            if (this.allItemsSelected) {
                this.toggleExcluded(key, state);

                if (state) {
                    this.toggleRelatedItems(key);
                }

                this.$nextTick(() => this.updateHeaderState());
                return;
            }

            if (state) {
                this.addSelectedItemId(Number.parseInt(key, 10));
                this.toggleRelatedItems(key);
            } else {
                this.removeSelectedItemId(Number.parseInt(key, 10));
            }

            if (!state) {
                this.selectedAll = false;
                this.$nextTick(() => this.updateHeaderState());
                return;
            }

            this.$nextTick(() => {
                if (Object.values(this.selectedIds).every((value) => value === true)) {
                    this.selectedAll = true;
                }

                this.updateHeaderState();
            });
        },

        toggleExcluded(key, state) {
            const id = Number.parseInt(key, 10);

            if (state) {
                this.excludedItemIds = this.excludedItemIds.filter((value) => value !== id);
                return;
            }

            if (!this.excludedItemIds.includes(id)) {
                this.excludedItemIds = [...this.excludedItemIds, id];
            }
        },

        toggleRelatedItems(key) {
            if (this.relatedItems[key] === undefined) {
                return;
            }

            this.relatedItems[key].forEach((relatedId) => {
                const relatedKey = String(relatedId)

                this.selectedIds[relatedKey] = true

                if (this.allItemsSelected) {
                    this.toggleExcluded(relatedKey, true)
                    return
                }

                this.addSelectedItemId(Number.parseInt(relatedKey, 10))
            })
        },

        onlySelectedIds() {
            return this.selectedItemIds;
        },

        selectAllResults() {
            this.allItemsSelected = true;
            this.excludedItemIds = [];
            this.syncSelection();
        },

        selectedCount() {
            if (this.allItemsSelected) {
                return Math.max(0, this.totalItems - this.excludedItemIds.length);
            }

            return this.selectedItemIds.length;
        },

        deselectAll() {
            this.selectedAll = false;
            this.toggleAll(false);
            this.allItemsSelected = false;
            this.selectedItemIds = [];
            this.excludedItemIds = [];
            this.syncSelection();
        },

        addSelectedItemId(id) {
            if (!this.selectedItemIds.includes(id)) {
                this.selectedItemIds = [...this.selectedItemIds, id];
            }
        },

        removeSelectedItemId(id) {
            this.selectedItemIds = this.selectedItemIds.filter((value) => value !== id);
        },

        updateHeaderState() {
            const values = Object.values(this.selectedIds);
            const selectedCount = values.filter((value) => value === true).length;
            const totalCount = values.length;

            this.selectedAll = totalCount > 0 && selectedCount === totalCount;

            if (!this.selectAllRef) {
                return;
            }

            const checkbox = this.$refs[this.selectAllRef];
            if (!checkbox) {
                return;
            }

            this.$nextTick(() => {
                checkbox.indeterminate = selectedCount > 0 && selectedCount < totalCount;
            });
        },
    }));
});
